import { Navigate, Outlet } from 'react-router';
import { useAuth } from '@/lib/auth';

/**
 * Route-level auth gate that prevents MainLayout from mounting
 * for unauthenticated users. Eliminates the shell flash on /auth.
 *
 * - loading → neutral spinner (no AppShell)
 * - no user → redirect to /auth
 * - authenticated → <Outlet /> (flows into MainLayout)
 */
export function RequireAuthLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return <Outlet />;
}
